import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

// Put the things into the DOM!
ReactDOM.render(<App />, document.getElementById("root"));
